import { useCallback, useState } from "react";
import { useNavigate } from "react-router";

export const useQRCodeHandler = () => {
  // context
  const navigate = useNavigate();
  // state
  const [qrCodeScannerOpen, setQrCodeScannerOpen] = useState(false);
  // handlers
  const handleQRCodeScanned = useCallback(
    (value: string) => {
      if (
        value.startsWith("https://www.musea.art.br/obras/") ||
        value.startsWith("https://www.musea.art.br/exibicoes/")
      ) {
        navigate(new URL(value).pathname); // TODO: queryparams?
      }
    },
    [navigate]
  );

  return {
    qrCodeScannerOpen,
    setQrCodeScannerOpen,
    handleQRCodeScanned,
  };
};
